// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Icon-module-icon-2q74e{display:inline-block;color:inherit;font-style:normal;line-height:0;text-align:center;text-transform:none;vertical-align:-0.125em;text-rendering:optimizelegibility;-webkit-font-smoothing:antialiased}.Icon-module-flip-2B4Oh{transform:scaleX(-1)}", ""]);
// Exports
exports.locals = {
	"icon": "Icon-module-icon-2q74e",
	"flip": "Icon-module-flip-2B4Oh"
};
module.exports = exports;
